import { IoClose } from "react-icons/io5";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { resolveMediaUrl } from "../../utility/media";

const ViewComplaintDetailsModal = ({ isOpen, onClose, complaint }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    if (!isOpen || !complaint) return null;

    return (
        <div className="staff-modal-overlay">
            <div className="staff-modal" style={{ width: '900px', maxWidth: '95%' }}>
                {/* Modal Header per image_0ca234.png */}
                <div className="staff-modal-header" style={{ background: '#a0adf1', borderBottom: '1px solid #979797' }}>
                    <div className="staff-modal-title" style={{ color: 'white', width: '100%', textAlign: 'center' }}>
                        {t('complaint.complaintDetails')}
                    </div>
                    <button className="staff-modal-close" onClick={onClose} style={{ color: 'white' }} >
                        <IoClose size={22} />
                    </button>
                </div>

                <div className="staff-form-body bg-white px-8 py-6" style={{ maxHeight: '80vh', overflowY: 'auto' }}>
                    {/* Primary Complaint Information Grid */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-x-12 gap-y-3 mb-8">
                        <InfoRow label={t('Complainer Name')} value={complaint.complainerName} />
                        <InfoRow label={t('Complaint Against')} value={complaint.complainAgainst} />

                        <div className="col-span-2 flex items-start text-sm">
                            <label className="w-44 font-bold text-gray-600 text-right">{'Complain'} (*)</label>
                            <span className="px-3 font-bold text-gray-800">:</span>
                            <div className="flex-1 font-bold text-gray-800 whitespace-pre-wrap">
                                {complaint.complaintDetails}
                            </div>
                        </div>

                        <InfoRow label={'Complaint Date'} value={complaint.complaintDate} />
                        <InfoRow label={'Department'} value={complaint.departmentName} />
                    </div>

                    {/* Attachments Table per image_0ca234.png */}
                    <div className="overflow-hidden border border-gray-400 rounded-sm">
                        <table className="w-full text-sm border-collapse">
                            <thead>
                                <tr className="bg-gray-100 border-b border-gray-400">
                                    <th className="p-2 text-center border-r border-gray-400 font-bold w-12">{t('tables.srNo')}</th>
                                    <th className="p-2 border-r border-gray-400 font-bold text-center">{t('common.description')}</th>
                                    <th className="p-2 text-center font-bold w-64">{t('common.attachments')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {complaint.attachments && complaint.attachments.length > 0 ? (
                                    complaint.attachments.map((item, index) => (
                                        <tr key={item.id || index} className="border-b border-gray-400 last:border-0">
                                            <td className="p-2 text-center border-r border-gray-400">{index + 1}</td>
                                            <td className="p-2 pl-4 text-left border-r border-gray-400 font-medium">
                                                {/* attachment JSON keys are lowercase */}
                                                {item.description || "N/A"}
                                            </td>
                                            <td className="p-2 text-center">
                                                {item.fileUrl ? (
                                                    <a
                                                        href={resolveMediaUrl(item.fileUrl)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-blue-600 underline hover:text-blue-800 break-all"
                                                    >
                                                        {item.fileName || t('common.view')}
                                                    </a>
                                                ) : (
                                                    <span className="text-gray-400 italic">{t('forms.common.noFile')}</span>
                                                )}
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="3" className="p-4 text-center text-gray-500 italic">{t('common.noRecords')}</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer */}
                <div className="staff-form-footer p-4 flex justify-center border-t bg-gray-50 rounded-b-2xl">
                    <button
                        className="staff-btn-save"
                        onClick={onClose}
                    >
                        {t('common.close')}
                    </button>
                </div>
            </div>
        </div>
    );
};

// Internal Helper for consistent Row Labeling
const InfoRow = ({ label, value }) => (
    <div className="flex items-center text-sm">
        <label className="w-44 font-bold text-gray-600 text-right">{label}</label>
        <span className="px-3 font-bold text-gray-800">:</span>
        <span className="flex-1 font-bold text-gray-800">{value || "N/A"}</span>
    </div>
);

export default ViewComplaintDetailsModal;